import {
  LEGACY_PROPERTY_TYPE_MAP,
  PROPERTY_TYPE_VALUES,
  getPropertyTypeLabel,
  isPropertyType,
  normalizePropertyType,
} from "@/src/constants/propertyTypes";
import type { PropertyType } from "@/src/types/propertyApi.types";

const DEFAULT_PROPERTY_TYPE: PropertyType = "SINGLE_FAMILY_HOME";

export const mapPropertyTypeToApi = (displayType: string): PropertyType => {
  const normalized = normalizePropertyType(displayType);
  if (normalized) return normalized;

  const lower = displayType.trim().toLowerCase();
  if (!lower) {
    return DEFAULT_PROPERTY_TYPE;
  }

  if (lower.includes("single") && lower.includes("family")) {
    return "SINGLE_FAMILY_HOME";
  }
  if (lower.includes("condo") || lower.includes("condominium")) {
    return "CONDOMINIUM";
  }
  if (lower.includes("apartment")) {
    return "APARTMENT";
  }
  if (lower.includes("townhome") || lower.includes("town house") || lower.includes("townhouse")) {
    return "TOWNHOME";
  }
  if (lower.includes("duplex")) {
    return "DUPLEX";
  }
  if (lower.includes("multi") && lower.includes("family")) {
    return "MULTI_FAMILY";
  }
  if (lower.includes("vacation")) {
    return "VACATION_HOME";
  }
  if (lower.includes("rental")) {
    return "RENTAL_PROPERTY";
  }
  if (lower.includes("office")) {
    return "OFFICE";
  }
  if (lower.includes("warehouse")) {
    return "WAREHOUSE";
  }
  if (lower.includes("industrial")) {
    return "INDUSTRIAL";
  }
  if (lower.includes("marina")) {
    return "MARINA";
  }
  if (lower === "rv" || lower.includes("recreational vehicle")) {
    return "RV";
  }
  if (lower.includes("yacht")) {
    return "YACHT";
  }
  if (lower.includes("boat")) {
    return "BOAT";
  }

  return DEFAULT_PROPERTY_TYPE;
};

export const formatPropertyTypeForDisplay = (propertyType: PropertyType | string): string =>
  getPropertyTypeLabel(propertyType);

export { PROPERTY_TYPE_VALUES as API_PROPERTY_TYPES, LEGACY_PROPERTY_TYPE_MAP };
